
class AppEnvironment {
  context: any;
}

export const appEnvironment = new AppEnvironment();
